import * as React from 'react';
import * as style from './ForumAppStyle.module.scss'
import store from './features/store';
import { ErrorBoundary } from "@appsignal/react";
import BttfAxios from '@features/utils/axios';
import Loader from '@appComponents/Loader/Loader';
import IForum, { TFeedState } from './interfaces/IForum';
import { FeedPage } from '@company/pages/FeedPage/FeedPage';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ENHANCED_MARKET } from '@bundles/consts';

import { appsignal } from "./../../appsignal";

export default class ForumApp extends React.Component<IForum, TFeedState> {
  state: TFeedState = {
    companyData: undefined,
    isCreator: false,
    isOwner: false,
    isUsInvestor: false,
    isDiscussion: false,
    error: false,
  };

  componentDidMount() {
    BttfAxios.get(`/api/companies/${this.props.company_slug}`, (res) => {
      this.setState({
        companyData: res.data,
        isCreator: this.props.user_profile_id === res.data.creator_id,
        isOwner: this.props.user_profile_id === res.data.profile_id,
        isUsInvestor: ENHANCED_MARKET.includes(this.props.user_country),
        isDiscussion: ['live_listed', 'live_unlisted'].includes(this.props.pitch_status),
      });
    }, (err) => {
      this.setState({ error: true });
    });
  }

  render() {
    return (
      <ErrorBoundary instance={appsignal}>
        {this.state.companyData ? (
          <Provider store={store}>
            <BrowserRouter>
            <div className={style.forumContainer}>
                <h2>{this.state.isDiscussion ? 'Discussion' : 'Investor Zone'}</h2>
                <FeedPage
                  funding={[]}
                  newFunding={{
                    funding: [],
                  }}
                  livePitch={null}
                  isUsInvestor={this.state.isUsInvestor}
                  companyId={this.state.companyData.id}
                  isAllowed={this.props.user_signed_in}
                  userProfileId={null}
                  userSignedIn={this.props.user_signed_in}
                  hasInvestorAccess={this.state.companyData.current_user_investor_access}
                  tmp={this.state.isDiscussion ? 'discussion' : 'investor_zone'}
                  isCreator={this.state.isCreator}
                  isOwner={this.state.isOwner}
                  profileId={this.state.companyData.profile_id}
                  profileAvatar={this.props.user_avatar}
                  push={() => {}}
                  externalForum={true}
                  externalForumPitchId={this.props.pitch_id}
                />
              </div>
            </BrowserRouter>
          </Provider>
        )
        : this.state.error ? null : <Loader />}
      </ErrorBoundary>
    );
  }
}
